'use client'

import type { InjectionWidgetComponentProps } from '@open-mercato/shared/modules/widgets/injection'

export default function RailTrackingPositionsTab({ context }: InjectionWidgetComponentProps) {
  return (
    <div className="space-y-2">
      <p className="text-sm text-muted-foreground">
        Rail GPS position history for this tracking event.
      </p>
    </div>
  )
}
